import React from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Skeleton,
} from "@mui/material";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../../../firebase-config";
import { useParams } from "react-router-dom";

export default function CompanyOverview() {
  const [data, setData] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  let params = useParams();
  const id = params.companyId;

  React.useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const docRef = doc(db, "companies-overview", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setData(docSnap.data());
        setLoading(false);
      } else {
        // doc.data() will be undefined in this case
        setData({});
        setLoading(false);
      }
    }
    // Fetch company overview
    fetchData();
  }, [id]);

  const list = Array.from({ length: 16 }, (v, k) => k + 1);

  return loading ? (
    <>
      <Grid container spacing={2}>
        {list.map((index) => {
          return (
            <Grid item xs={12} md={6} key={index}>
              <Card>
                <CardContent>
                  <Typography variant="h6">
                    <Skeleton width="50%" sx={{ bgcolor: "white" }} />
                  </Typography>
                  <Typography variant="subtitle2">
                    <Skeleton sx={{ bgcolor: "white" }} />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </>
  ) : Object.keys(data).length === 0 ? (
    <Typography variant="h6" align="center">
      No Data Available
    </Typography>
  ) : (
    <Box>
      {data["name"] === undefined ? (
        <></>
      ) : (
        <Box sx={{
          mb: 3
        }}>
          <Typography variant="h4" align="center">
            {data["name"].length === 0 ? "-" : data["name"]}
          </Typography>
        </Box>
      )}
      <Grid container spacing={2}>
        {data["year-of-incorporation"] === undefined ? (
          <></>
        ) : (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">Year of Incorporation</Typography>
                <Typography variant="subtitle2">
                  {data["year-of-incorporation"].length === 0
                    ? "-"
                    : data["year-of-incorporation"]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}

        {data["address"] === undefined ? (
          <></>
        ) : (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">Corporate Address</Typography>
                <Typography variant="subtitle2">
                  {data["address"].length === 0 ? "-" : data["address"]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}

        {data["name"] === undefined ? (
          <></>
        ) : (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">Official Name</Typography>
                <Typography variant="subtitle2">
                  {data["name"].length === 0 ? "-" : data["name"]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}

        {data["industry"] === undefined ? (
          <></>
        ) : (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">Industry</Typography>
                <Typography variant="subtitle2">
                  {data["industry"].length === 0 ? "-" : data["industry"]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}

        {data["sector"] === undefined ? (
          <></>
        ) : (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">Sector</Typography>
                <Typography variant="subtitle2">
                  {data["sector"].length === 0 ? "-" : data["sector"]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}

        {data["sub-industry"] === undefined ? (
          <></>
        ) : (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">Sub-Industry</Typography>
                <Typography variant="subtitle2">
                  {data["sub-industry"].length === 0
                    ? "-"
                    : data["sub-industry"]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}

        {data["country-of-incorporation"] === undefined ? (
          <></>
        ) : (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">Country of Incorporation</Typography>
                <Typography variant="subtitle2">
                  {data["country-of-incorporation"].length === 0
                    ? "-"
                    : data["country-of-incorporation"]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}

        {data["email"] === undefined ? (
          <></>
        ) : (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">Corporate Email</Typography>
                <Typography variant="subtitle2">
                  {data["email"].length === 0 ? "-" : data["email"]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}

        {data["phone-number"] === undefined ? (
          <></>
        ) : (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">Corporate Phone Number</Typography>
                <Typography variant="subtitle2">
                  {data["phone-number"].length === 0
                    ? "-"
                    : data["phone-number"]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}

        {data["total-employees"] === undefined ? (
          <></>
        ) : (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">Total Employees</Typography>
                <Typography variant="subtitle2">
                  {data["total-employees"].length === 0
                    ? "-"
                    : data["total-employees"]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}

        {data["website"] === undefined ? (
          <></>
        ) : (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">Corporate Website</Typography>
                <Typography variant="subtitle2">
                  {data["website"].length === 0 ? "-" : data["website"]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}

        {data["hq-city"] === undefined ? (
          <></>
        ) : (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">HQ City</Typography>
                <Typography variant="subtitle2">
                  {data["hq-city"].length === 0 ? "-" : data["hq-city"]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}

        {data["hq-office-address"] === undefined ? (
          <></>
        ) : (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">HQ Office Address</Typography>
                <Typography variant="subtitle2">
                  {data["hq-office-address"].length === 0
                    ? "-"
                    : data["hq-office-address"]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}

        {data["county"] === undefined ? (
          <></>
        ) : (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">County</Typography>
                <Typography variant="subtitle2">
                  {data["county"].length === 0 ? "-" : data["county"]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
